/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForCorestack extends models.ServiceAccountCredentialsForBasicAuth {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForCorestack");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForCorestack.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForCorestack>): ServiceAccountCredentialsForCorestack {
        let obj = Object.assign(new ServiceAccountCredentialsForCorestack(), model);
        ServiceAccountCredentialsForCorestack.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForCorestack>): ServiceAccountCredentialsForCorestack {
        if (!model) return null;
        return ServiceAccountCredentialsForCorestack.newInstance(<ServiceAccountCredentialsForCorestack> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForCorestack) {
        if (!obj) return;

        models.ServiceAccountCredentialsForCorestack.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForCorestack): boolean {
        if (models.ServiceAccountCredentialsForBasicAuth.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForCorestack.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
